import React from 'react';

// 3-state clarity for the doctor/clinic commission-payout tables: an order's
// provision can be undelivered (no ledger entry yet), delivered but still
// pending payout, or already paid. Single source of truth for both the
// per-row badge and the legend shown above each table, and for whether a
// row's checkbox should be selectable.
const FULFILLED_STATUSES = ['delivered', 'ready_for_pickup'];

export const PAYOUT_STATUSES = [
  {
    key: 'undelivered',
    label: 'Nije isporučeno',
    dot: '#98A2B3',
    bg: '#F2F4F7',
    text: '#344054',
  },
  {
    key: 'pending',
    label: 'Čeka realizaciju',
    dot: '#DC6803',
    bg: '#FEF0C7',
    text: '#DC6803',
  },
  {
    key: 'paid',
    label: 'Realizovano',
    dot: '#027A48',
    bg: '#ECFDF3',
    text: '#027A48',
  },
];

const PAYOUT_STATUS_BY_KEY = Object.fromEntries(
  PAYOUT_STATUSES.map((s) => [s.key, s])
);

export const resolvePayoutStatusKey = (row) => {
  if (row?.payoutStatus === 'paid') return 'paid';
  if (FULFILLED_STATUSES.includes(row?.status)) return 'pending';
  return 'undelivered';
};

export const formatPayoutStatusAsPill = (row) => {
  const { label, bg, text } = PAYOUT_STATUS_BY_KEY[resolvePayoutStatusKey(row)];
  return (
    <span
      style={{
        padding: '4px 12px',
        borderRadius: '16px',
        fontSize: '14px',
        fontWeight: '500',
        display: 'inline-block',
        backgroundColor: bg,
        color: text,
      }}
    >
      {label}
    </span>
  );
};

export const payoutStatusLabel = (row) =>
  PAYOUT_STATUS_BY_KEY[resolvePayoutStatusKey(row)].label;
